import { Table, ConfigProvider, Empty } from 'antd';

const paginationConfig = {
  defaultPageSize: 20,
  showSizeChanger: true,
  pageSizeOptions: ['20', '50', '100', '500', '1000', '3000'],
  position: ['bottomCenter'],
  showTotal: (total) => `총 ${total}건`
};
const statPagenationConfig = {
    defaultPageSize: 30,
    showSizeChanger: false,
    // pageSizeOptions: ['21', '', '60', '150'],
    position: ['bottomCenter'],
    showTotal: (total) => `총 ${total/3}건`
}
/**
 * rowKey : 고유 키(중요)
 * columns : column 정의
 * data : data
 * pagination : 페이지 처리 여부
 * @returns
 */
export function DataGrid({ virtual = false, rowKey, columns, data, footer = undefined, summary = undefined, pagination, bordered = true, showHeader = true, loading = false, scrollX = true, scrollY, rowSelection, onRow, size = 'small', rowClassName = undefined, emptyText = '', setPage = undefined, className, rowHoverable=true, statPage }) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: '#ebebeb',
            headerBorderRadius: 0
          }
        }
      }}
    >
      <Table
        virtual={virtual}
        responsive
        className={`${className} ${bordered ? 'ant-table-bordered' : ''}`}
        bordered={bordered || false}
        showHeader={showHeader}
        rowKey={rowKey}
        columns={columns}
        dataSource={data}
        pagination={
          pagination
            ? {
                ...(statPage ? statPagenationConfig : paginationConfig),
                ...(setPage && {
                  onChange: (page, pageSize) => {
                    setPage({ page: page, pageSize: pageSize });
                  }
                })
              }
            : false
        }
        loading={loading}
        // style={{ overflowX: scrollX ? 'scroll' : 'none' }}
        scroll={{ x: virtual ? 300 : scrollX ? scrollX : false, y: scrollY }}
        rowSelection={rowSelection}
        footer={footer}
        onRow={onRow}
        summary={summary}
        size={size}
        rowClassName={rowClassName}
        locale={{
          emptyText: emptyText ? (
            emptyText
          ) : (
            <div>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )
        }}
        rowHoverable={rowHoverable}
      />
    </ConfigProvider>
  );
}

export function DataGrid2({ rowKey, columns, data, footer = undefined, pagination, bordered, showHeader = true, loading = false, scrollX, scrollY, rowSelection, onRow = null }) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: '#ebebeb',
            headerBorderRadius: 0,
            borderColor: '#d9d9d9'
          }
        }
      }}
    >
      <div className="second-table">
        <Table
          responsive
          className={'component-datagrid'}
          bordered={bordered || false}
          showHeader={showHeader}
          rowKey={rowKey}
          columns={columns}
          dataSource={data}
          pagination={pagination ? paginationConfig : false}
          loading={loading}
          // style={{ overflowX: scrollX ? 'scroll' : 'none' }}
          scroll={{ x: scrollX, y: scrollY }}
          rowSelection={rowSelection}
          onRow={onRow}
          style={{ borderTop: 'none' }}
          footer={footer}
        />
      </div>
    </ConfigProvider>
  );
}
